import { z } from 'zod';
import { localeSchema, roleSchema } from './auth.ts';

export const memberSchema = z.object({
  id: z.uuid(),
  displayName: z.string(),
  role: roleSchema,
  /** The signed-in user. */
  isMe: z.boolean(),
});
export type Member = z.infer<typeof memberSchema>;
export const membersSchema = z.object({ members: z.array(memberSchema) });

export const pendingInviteSchema = z.object({
  id: z.uuid(),
  createdBy: z.string().nullable(),
  createdAt: z.iso.datetime(),
  expiresAt: z.iso.datetime(),
});
export type PendingInvite = z.infer<typeof pendingInviteSchema>;
export const pendingInvitesSchema = z.object({ invites: z.array(pendingInviteSchema) });

/** Returned once when an invite is created: the link carries the only copy of the token. */
export const createdInviteSchema = z.object({
  id: z.uuid(),
  url: z.url(),
  expiresAt: z.iso.datetime(),
});
export type CreatedInvite = z.infer<typeof createdInviteSchema>;

/** What an invitee sees before accepting. */
export const inviteInfoSchema = z.discriminatedUnion('valid', [
  z.object({ valid: z.literal(true), householdName: z.string(), invitedBy: z.string().nullable() }),
  z.object({ valid: z.literal(false) }),
]);
export type InviteInfo = z.infer<typeof inviteInfoSchema>;

export const acceptInviteRequestSchema = z.object({
  displayName: z.string().trim().min(1).max(60),
  locale: localeSchema,
});
export type AcceptInviteRequest = z.infer<typeof acceptInviteRequestSchema>;
